(function () {
  'use strict';

  function pollerLite(conditions, callback, options = {}) {
    const config = Object.assign({ wait: 50, multiplier: 1.1, timeout: 0 }, options);
    const start = Date.now();
    const timeoutAt = config.timeout ? start + config.timeout : 0;
    const successes = [];

    function check(condition) {
      if (typeof condition === 'function') return condition();
      if (typeof condition === 'string') return document.querySelector(condition);
      return false;
    }

    function timedOut() {
      return timeoutAt && Date.now() > timeoutAt;
    }

    function poll(condition, wait) {
      if (timedOut()) return;
      const result = check(condition);
      if (result) {
        successes.push(result);
        if (successes.length === conditions.length) callback(successes);
      } else {
        setTimeout(() => poll(condition, wait * config.multiplier), wait);
      }
    }

    conditions.forEach((c) => poll(c, config.wait));
  }

  function formatTitle(separator = '|') {
    const titleEl = document.querySelector('.product-title');
    if (!titleEl) return;

    const fullText = titleEl.textContent.trim();
    if (!fullText.includes(separator)) return;

    const [firstPart, ...rest] = fullText.split(separator);
    const secondPart = rest.join(separator).trim();

    titleEl.innerHTML = `
      <span class="pdp-title" aria-label="${fullText}">
        <span class="pdp-title__first">${firstPart.trim()}</span>
        <span class="pdp-title__second">${secondPart}</span>
      </span>`;
  }

  function moveSKU() {
    pollerLite(['.product-vendor-sku', '.product-description'], () => {
      const sku = document.querySelector('.product-vendor-sku');
      const desc = document.querySelector('.product-description');
      if (sku && desc) desc.appendChild(sku);
    });
  }

  function moveStock() {
    pollerLite(['.pickup-status', '.product-info__block'], () => {
      const stock = document.querySelector('.product-inventory.product-info__block');
      const pickup = document.querySelector('.pickup-status');
      if (stock && pickup) pickup.insertAdjacentElement('beforebegin', stock);
    });
  }


  pollerLite(['.product-title'], () => {
    document.documentElement.classList.add('pdp-title-layout');
    formatTitle('|');
    moveSKU();
    moveStock();
  });

})();
